<template>
  <div class="container md-layout">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>

    <div class="md-layout-item md-size-100" v-else>
      <md-table md-card>
        <md-table-toolbar>
          <h1 class="md-title">{{ $t("teams.list.title") }}</h1>
        </md-table-toolbar>

        <md-table-row>
          <md-table-head>{{$t('teams.list.name')}}</md-table-head>
          <md-table-head>{{$t('teams.list.edit')}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="team in listTeams" :key="team.id">
          <md-table-cell>{{team.name}}</md-table-cell>
          <md-table-cell>
              <md-button class="md-info" :to="`/team/${team.id}`">
              {{$t('teams.list.edit')}}

              </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: true
    };
  },
  computed: {
    ...mapState({
      listTeams: state => state.StuffModule.teams
    })
  },
  created() {
    this.$store.dispatch("teamsGet")
      .then(() => this.loading = false)
  }
};
</script>
